(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/stream-player/assets/javascripts/drop-down-header.js') >= 0) return;  svs.modules.push('/components/racing/stream-player/assets/javascripts/drop-down-header.js');

'use strict';

const useState = React.useState;
const useEffect = React.useEffect;
const getRaceInit = svs.racing.getRaceInit;
const Flag = svs.lb_ui.ReactFlag;
const gameTypes = svs.racing.common.constants.gameTypes;
const {
  raceHasGameType
} = svs.racing.common.util;
const GameTypeTag = svs.racing.gameTypeTag.GameTypeTag;
const RenderContent = _ref => {
  let {
    hasTop5,
    raceCard
  } = _ref;
  return React.createElement("div", {
    className: "race-card-info f-400 f-inverted"
  }, React.createElement("div", {
    className: "race-card-info-top"
  }, React.createElement("div", {
    className: "track-and-racenumber f-bold"
  }, React.createElement("span", {
    className: "item-flag-and-track"
  }, raceCard.countryCode && React.createElement(Flag, {
    iso: raceCard.countryCode,
    size: "100"
  }), "\xA0", " ".concat(raceCard.meeting.track.name))), React.createElement("div", {
    className: "time-left"
  }, getRaceInit(raceCard.startTime, raceCard.raceStatus))), React.createElement("div", {
    className: "race-card-info-middle"
  }, React.createElement("div", {
    className: "race-number"
  }, "Lopp ".concat(raceCard.raceNumber)), hasTop5 && React.createElement(GameTypeTag, {
    gameType: gameTypes.TOPP5
  }), React.createElement("div", {
    className: "".concat(hasTop5 ? 'meeting-race-number' : '')
  }, "[M".concat(raceCard.meeting.meetingNumber, "R").concat(raceCard.raceNumber, "]"))), React.createElement("div", {
    className: "race-card-info-bottom"
  }, React.createElement("div", {
    className: "race-details"
  }, raceCard.description), React.createElement("div", {
    className: "arrow-holder"
  }, React.createElement("button", {
    className: "drop-down-header-arrow-button",
    title: "",
    type: "button"
  }, React.createElement("i", {
    className: "icon icon-100 icon-menu-down"
  })))));
};
const DropDownHeader = _ref2 => {
  let {
    handleClick,
    noRaceData,
    handleThumbnailClick,
    setFolded,
    folded,
    thumbnail
  } = _ref2;
  const getRacecardData = svs.racing.streamplayer.StreamPlayerDataHandler.getRacecardData;
  const [raceCard, setRaceCard] = useState(undefined);
  const [hasError, setHasError] = useState(false);
  const [hasTop5, setHasTop5] = useState(false);
  useEffect(() => {
    getRacecardData(data => {
      if (data) {
        setHasError(data.hasError);
        if (!data.hasError) {
          data.raceCard = !data.raceCard ? {} : data.raceCard;
          if (data.raceCard && data.raceCard.meeting) {
            setRaceCard(data.raceCard);
            setHasTop5(raceHasGameType(data.raceCard, gameTypes.TOPP5));
          } else {
            noRaceData();
          }
        }
      }
    });
  }, [getRacecardData, noRaceData]);
  const clickedThumbnail = () => {
    setFolded(false);
    handleThumbnailClick();
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "drop-down-header",
    onClick: () => handleClick(true)
  }, React.createElement("div", {
    className: "race-info-background"
  }, (() => {
    if (hasError) {
      return React.createElement("div", {
        className: "race-card-error "
      }, React.createElement("div", {
        className: "error-info f-700 f-inverted"
      }, React.createElement("span", {
        className: "margin-xs-right"
      }, "LIVE "), React.createElement("i", {
        className: "icon icon-500 icon-tv"
      })), React.createElement("div", {
        className: "arrow-holder"
      }, React.createElement("i", {
        className: "icon icon-100 icon-menu-down"
      })));
    }
    if (raceCard && raceCard.meeting) {
      return React.createElement(RenderContent, {
        hasError: hasError,
        hasTop5: hasTop5,
        raceCard: raceCard
      });
    }
  })())), raceCard && raceCard.meeting && thumbnail && folded && React.createElement("div", {
    className: "player show-thumbnail",
    onClick: clickedThumbnail,
    style: {
      backgroundImage: "url(".concat(thumbnail, ")")
    }
  }, React.createElement("i", {
    className: "icon icon-marker fc-red"
  }), React.createElement("span", {
    className: "f-center f-inverted f-uppercase f-600"
  }, "LIVE")));
};
svs.racing.streamplayer.DropDownHeader = DropDownHeader;

 })(window);